export default "__VITE_ASSET__U7qJiysz5ZuhEgSdAd7riA__"